import clsx from 'clsx';
import { useState } from 'react';
import { IconButton } from '@trg/tlw-ui-component';
import { useHeaderData } from '../../../hooks';
import { selectIsLogin } from '../../../api';
import { MemberDropdown } from './MemberDropdown';

export interface MemberProps {
  hasDropdown?: boolean;
}

export function Member({ hasDropdown }: MemberProps) {
  const data = useHeaderData();
  const isLogin = selectIsLogin(data);
  const destination = isLogin ? '/my-account/index' : '/memberLogin';
  const hello = `你好，${data?.customerMaskName ?? '會員'}`;

  const [isDropdownOpen, setDropdownOpen] = useState(false);

  return (
    <div
      className={clsx(
        'tlw-group/status-member tlw-relative tlw-flex',
        !hasDropdown && 'tlw-px-2'
      )}
      onMouseEnter={() => setDropdownOpen(true)}
      onMouseLeave={() => setDropdownOpen(false)}
    >
      <IconButton
        className="tlw-flex tlw-items-center tlw-gap-1 tlw-p-0 tlw-text-2xl lg:tlw-text-xl group-hover/status-member:tlw-text-txt-core"
        icon="User"
        href={destination}
        square
      >
        <span className={clsx('tlw-txt-zh-head-8', !hasDropdown && 'tlw-px-2')}>
          {isLogin ? hello : hasDropdown ? '' : '會員登入'}
        </span>
      </IconButton>

      {hasDropdown && <MemberDropdown isOpen={isDropdownOpen} />}
    </div>
  );
}
